<template>
  <div class="square-compare">
    <div class="square-compare-title">
      <span class="f-ui-1-bold">{{ data.source }}</span>
    </div>
    <div class="square-compare-container">
      <div class="square-divider">
        <div
          v-for="(item, idx) in shownItems"
          :key="`square-${idx}`"
          class="square"
          :class="{
            'square__section--historic': idx === 0,
            'square__section--today': idx === 1,
            'square__section--STEPS': idx === 2,
            'square__section--APS': idx === 3,
          }"
        >
          <div v-if="data.type === 'instruction'" class="square-value__label">
            <span v-if="idx === 0">TWh</span>
          </div>
          <div v-else v-show="item.val > 0" class="square-value__label">
            {{ Math.ceil(item.val) }}
          </div>
          <div
            class="square-value"
            :style="{
              height: `${(Math.sqrt(item.val) * 100) / Math.sqrt(max)}%`,
              width: `${(Math.sqrt(item.val) * 100) / Math.sqrt(max)}%`,
              background: `${colors[data.type]}`,
            }"
          >
            <span
              v-if="data.label"
              v-show="showScenarioLabels"
              class="f-ui-2-bold"
              >{{ scenarioLabels[idx] }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
export default {
  props: {
    data: {
      type: Object,
    },
    scenarioLabels: {
      type: Array,
    },
    max: {
      type: Number,
    },
  },
  data() {
    return {
      shownItems: [],
      showScenarioLabels: false,
      colors: {
        unabated: "#d8d4c0",
        other: "#646464",
        nuclear: "#d65a40",
        renewables: "#64a8c1",
        instruction: "#C4C3bb",
      },
    };
  },
  mounted() {
    this.shownItems = [{ val: 0 }, { val: 0 }, { val: 0 }, { val: 0 }];
    this.shownItems.forEach((item, i) => {
      const final = this.data.data;
      gsap.to(item, {
        val: final[i],
        duration: 1,
        delay: i * 0.4,
      });
    });
    setTimeout(() => (this.showScenarioLabels = true), 2000);
  },
};
</script>

<style scoped>
.square-compare {
  display: flex;
  flex-flow: column;
  width: 33.3%;
  margin: 10px 0;
}
.square-compare-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 10vh;
  padding: 10px;
}
.square-compare-title {
  padding: 10px 0;
  display: flex;
  justify-content: center;
}
.square-divider {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1px;
  background: #000;
  width: 160px;
}
.square {
  position: relative;
  margin: 0;
  padding: 0;
  background-color: #fff;
  aspect-ratio: 1;
}
.square__section--historic {
  background: #fff;
}
.square-value {
  display: flex;
  align-items: center;
  justify-content: center;
}
.square-value span {
  text-align: center;
  line-height: 1rem;
}
.square-value,
.square-value__label {
  position: absolute;
  float: right;
}
.square-value__label {
  z-index: 2;
}
.square__section--APS .square-value__label,
.square__section--historic .square-value {
  bottom: 0;
  right: 0px;
}
.square__section--today .square-value,
.square__section--STEPS .square-value__label {
  bottom: 0;
  left: 0px;
}
.square__section--today .square-value__label,
.square__section--STEPS .square-value {
  top: 0;
  right: 0px;
}
.square__section--APS .square-value {
  top: 0;
  left: 0px;
}

@media screen and (max-width: 1024px) {
  .square-compare {
    width: 33.3%;
  }
  .square-divider {
    width: 100px;
  }
  .square-value__label {
    font-size: 0.75rem;
  }
  .square-value span {
    font-size: 0.75rem;
    line-height: 0.75rem;
  }
  .square-compare-title span {
    font-size: 0.85rem;
    line-height: 0.85rem;
  }
}
</style>
